import React from 'react';
import styles from './style.module.css';
import StepFourForm from '../../components/forms/step-four';
import InfoBox from '../../../../common/components/info-box';

const tooltip = {
    title: 'What do I choose?',
    content: <span>We are here to help you visualize your prosperity goals. <strong>Assess My Finances</strong> route will help you take into account any financial information you want to address in your prosperity path. <strong>My Goals</strong> will skip the financial steps and take you directly to the goal setting portion of this calculator.</span>
};

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Choose Your Path To Prosperity</h1>
        <div className={styles.textContainer}>
            <p className={styles.text}>Take the deep dive and assess your current financial landscape, or take the shortened approach by focusing on setting your goals.</p>
        </div>
        <StepFourForm/>
        <InfoBox
            title={tooltip.title}
            content={tooltip.content}
        />
    </div>
);
